import { combineReducers } from '@reduxjs/toolkit'
import uploadListFiles from './upload-list-files.store'
import finishUpload from './finish-upload.store'

export const rootReducer = combineReducers({
  uploadListFiles,
  finishUpload,
})
